const REGISTRATION_PROMPT_DISMISSED_KEY = "emailMarketingRegistrationPromptDismissed"
const ORDER_PROMPT_DISMISSED_KEY = "emailMarketingOrderPromptDismissed"

const getUserScopedKey = (key: string, userId: number | null | undefined) => `${key}:${userId ?? "anonymous"}`

export const hasDismissedRegistrationEmailPrompt = (userId?: number | null) => localStorage.getItem(getUserScopedKey(REGISTRATION_PROMPT_DISMISSED_KEY, userId)) === "true"

export const dismissRegistrationEmailPrompt = (userId?: number | null) => {
  localStorage.setItem(getUserScopedKey(REGISTRATION_PROMPT_DISMISSED_KEY, userId), "true")
}

export const hasDismissedOrderEmailPrompt = (userId?: number | null) => sessionStorage.getItem(getUserScopedKey(ORDER_PROMPT_DISMISSED_KEY, userId)) === "true"

export const dismissOrderEmailPrompt = (userId?: number | null) => {
  sessionStorage.setItem(getUserScopedKey(ORDER_PROMPT_DISMISSED_KEY, userId), "true")
}
